import React, { useEffect } from 'react'
import Header from './header'
import Footer from './footer'
import AOS from "aos"
import "aos/dist/aos.css"

const Layout = ({ children }) => {
    useEffect(() => {
        AOS.init({
            duration: 1000,     
            once: true,      
            easing: 'ease-in-out',
            offset: 120,     
            delay: 0,
            anchorPlacement: 'top-bottom', 
        });

    
    }, []);

    return (

        <div className="flex flex-col font-neue"  style={{
        // backgroundColor: "#ffffff",
        backgroundImage: `
          linear-gradient(to right, rgba(240, 240, 240, 0.34) 1px, transparent 1px),
          linear-gradient(to bottom, rgba(240, 240, 240, 0.34) 1px, transparent 1px)
        `,
        backgroundSize: "40px 40px",
        backgroundAttachment: "fixed", 
        backgroundRepeat: "repeat",
        width: "100%",
      }}>
            <Header />
            <main className="flex-grow">
                {children}
            </main>
            <Footer />
        </div>
    )
}

export default Layout